import { getNodes, noop } from './shared';
/**
 * Listens to the specified `type` of events and calls `onEvent` when one fires
 * within one of the `targets`.
 * @param type Types of events to listen to.
 * @param target Nodes or RefObjects of nodes to listen on.
 * @param onEvent Function to call when one of the events fires.
 * @param options EventListener options.
 */
export function listen(type, target, onEvent, options) {
    const types = [type].flat();
    const nodes = getNodes(target);
    if (!onEvent || !types.length || !nodes.length)
        return noop;
    const listening = nodes.flatMap((node) => types.map((type) => on(type, node, onEvent, options)));
    return () => listening.forEach(stop);
}
const on = (type, node, onEvent, options) => {
    const element = node;
    element.addEventListener(type, onEvent, options);
    return () => element.removeEventListener(type, onEvent, options);
};
const stop = (fn) => fn();
//# sourceMappingURL=listen.js.map